<template lang="pug">
  .file
    .file__content
      Icon.file__icon(v-if="!isImg" :icon="icon")

      Avatar(
        v-if="isImg"
        box
        :img="file.url"
        :style="{cursor: 'pointer'}"
        @click.native="openFile"
      )
      p.file__text(v-else @click="openFile")
        | {{editFileNameLength}}

    .file__delete(v-if="canDelete" @click="deleteFile")
      Icon.file__delete-icon(icon="close")

</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: () => 'file'
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    file: {
      type: Object,
      default: () => ({
        fileName: '',
        url: ''
      })
    }
  },
  computed: {
    editFileNameLength() {
      const oldFileName = this.file.fileName;
      let newFileName;

      if (oldFileName.length > 16) {
        const firstTenLetters = oldFileName.substring(0, 10);
        const lastSixLetters = oldFileName.slice(-5);
        newFileName = `${firstTenLetters}...${lastSixLetters}`;
      } else {
        newFileName = oldFileName;
      }

      return newFileName;
    },
    isImg() {
      return (
        /image/gi.test(this.file.mimeType) ||
        /(jpg|jpeg|png|svg)$/gi.test(this.file.fileName)
      );
    }
  },
  methods: {
    deleteFile() {
      this.$emit('deleteFile', this.file);
    },
    openFile() {
      if (!this.file.url) {
        return;
      }

      if (/image/gi.test(this.file.mimeType)) {
        const image = new Image();
        image.src = this.file.url;

        const w = window.open('');
        w.document.write(image.outerHTML);
      } else {
        const win = window.open(this.file.url, '_blank');
        win.focus();
      }
    }
  }
};
</script>
